import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Truck, Headphones, Shield } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const Footer = () => {
  const { t, language } = useLanguage();

  return (
    <footer className="bg-zinc-950 border-t border-zinc-800">
      {/* Features Bar */}
      <div className="border-b border-zinc-800">
        <div className="container mx-auto px-4 py-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 rounded-full bg-zinc-900 flex items-center justify-center">
                <Truck className="h-6 w-6 text-white" />
              </div>
              <div>
                <h4 className="font-semibold text-white">{t.footer.delivery}</h4>
                <p className="text-sm text-zinc-500">{t.footer.deliveryDesc}</p>
              </div>
            </div>
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 rounded-full bg-zinc-900 flex items-center justify-center">
                <Headphones className="h-6 w-6 text-white" />
              </div>
              <div>
                <h4 className="font-semibold text-white">{t.footer.support}</h4>
                <p className="text-sm text-zinc-500">{t.footer.supportDesc}</p>
              </div>
            </div>
            <Link to="/warranty" className="flex items-center gap-4 hover:opacity-80 transition-opacity">
              <div className="w-12 h-12 rounded-full bg-zinc-900 flex items-center justify-center">
                <Shield className="h-6 w-6 text-white" />
              </div>
              <div>
                <h4 className="font-semibold text-white">{t.footer.quality}</h4>
                <p className="text-sm text-zinc-500">{language === 'hu' ? 'Garanciális feltételek →' : 'Warranty terms →'}</p>
              </div>
            </Link>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="container mx-auto px-4 py-12">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          {/* Logo & Copyright */}
          <div className="text-center md:text-left">
            <h3 className="text-2xl font-bold text-white mb-2">
              Shisha<span className="text-zinc-500">Vibes</span>
            </h3>
            <p className="text-sm text-zinc-500">
              © {new Date().getFullYear()} ShishaVibes. {t.footer.rights}
            </p>
          </div>

          {/* Links */}
          <div className="flex items-center gap-6 text-sm">
            <Link to="/warranty" className="text-zinc-400 hover:text-white transition-colors">
              {language === 'hu' ? 'Garancia' : 'Warranty'}
            </Link>
          </div>

          {/* Social */}
          <div className="flex items-center gap-4">
            <span className="text-zinc-500 text-sm">{t.footer.followUs}:</span>
            <a
              href="https://www.facebook.com/profile.php?id=61583331609027"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-full bg-zinc-900 hover:bg-zinc-800 flex items-center justify-center transition-colors"
              data-testid="footer-facebook-link"
              aria-label="Facebook"
            >
              <Facebook className="h-5 w-5 text-white" />
            </a>
            <a
              href="https://www.instagram.com/_shishavibes._/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-full bg-zinc-900 hover:bg-zinc-800 flex items-center justify-center transition-colors"
              data-testid="footer-instagram-link"
              aria-label="Instagram"
            >
              <Instagram className="h-5 w-5 text-white" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
